module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASlJREFUeNpiZMANBIBYGYilgZgXiG8D8Sk86pmAWAaIFYBYDIh5gHgDCxaFikDsDMSqQMyIJM6OwwJmILYEYlsgFkSTu4hugTsQO6EZDAMyWMT4gDgBhxwIyDMhcSyhLsdm+D8g/gjEnEhirECcjMfwH6Bgg/kAFF4+WBT9AeK9QHwciL+hydkBsSQWPa+BeCsQ3wA5jAXJ9axYFC8D4itYxBmhetDBWyCeDHU9POZBQA2L4qc4DAcBcWj4o4MDyIbDLGDGEY7P8CRJWRziT9EFWKDhz4xFsS40H8BAPxD/REo92EA8EP+Fsq8C8WYWtJSBDDigGDncYQCXHn4kNg9yHJAKWIlVSK4FDKMWjFqAkrbZQMUqEWrvQktVBmiFwk9A/WcgfgEQYADKWyYbWYAgawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./markup/img/quete_3.png
// module id = 1075
// module chunks = 0